export default __webpack_public_path__ + "static/media/more_vert_black_24dp.4060799d.svg";